import React, { useEffect } from 'react';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white min-h-screen pt-32 pb-24" data-id="element-608">
      <div className="max-w-4xl mx-auto px-6" data-id="element-609">
        <h1 className="text-4xl md:text-5xl font-serif mb-8 text-brand-black" data-id="element-610">
          Privacy Policy
        </h1>
        <p className="text-gray-500 mb-12 uppercase tracking-widest text-sm" data-id="element-611">
          Last Updated: January 2026
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed" data-id="element-612">
          <section data-id="element-613">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-614">
              1. Information We Collect
            </h2>
            <p data-id="element-615">
              At Versatile LLC Cater 2 U, we collect information that you
              provide directly to us when you request a quote, book an event,
              subscribe to our meal prep services, or communicate with us. This
              may include your name, email address, phone number, event details,
              dietary restrictions, and payment information.
            </p>
          </section>

          <section data-id="element-616">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-617">
              2. How We Use Your Information
            </h2>
            <p data-id="element-618">
              We use the information we collect to provide, maintain, and
              improve our catering services. Specifically, we use your
              information to process transactions, send booking confirmations,
              communicate about your event, and respond to your inquiries.
            </p>
          </section>

          <section data-id="element-619">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-620">
              3. Information Sharing
            </h2>
            <p data-id="element-621">
              We do not sell or rent your personal information to third parties.
              We may share your information with trusted third-party service
              providers who assist us in operating our business, such as payment
              processors and delivery partners, strictly for the purpose of
              fulfilling your service requests.
            </p>
          </section>

          <section data-id="element-622">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-623">
              4. Data Security
            </h2>
            <p data-id="element-624">
              We implement reasonable security measures to protect your personal
              information from unauthorized access, alteration, disclosure, or
              destruction. However, no method of transmission over the Internet
              or electronic storage is 100% secure.
            </p>
          </section>

          <section data-id="element-625">
            <h2 className="text-2xl font-serif text-brand-black mb-4" data-id="element-626">
              5. Contact Us
            </h2>
            <p data-id="element-627">
              If you have any questions about this Privacy Policy, please
              contact us at hello@versatilityeats.com or call us at (202)
              555-0123.
            </p>
          </section>
        </div>
      </div>
    </div>;
}